import { CmsConfig, CmsOrderDetailItemsComponent, PageMetaResolver } from "@spartacus/core";
import { GenAddressFormComponent } from "../shared/components/address-form/address-form.component";
import { GenBundleCarouselComponent } from "src/app/generac/features/bundle-carousel/bundle-carousel.component";
import { GenSavedAddressesComponent } from "../features/saved-addresses/saved-addresses.component";
import { GenProductFacetNavigationComponent } from "src/app/generac/shared/components/product-facet-navigation/product-facet-navigation.component";
import { GenProductImageZoomProductImagesComponent } from "../features/product/product-image-zoom-product-images/product-image-zoom-product-images.component";
import { GenShippingAccountsComponent } from "src/app/generac/features/shipping-accounts/shipping-accounts.component";
import { GenShippingAccountsResolver } from "src/app/generac/resolvers/shipping-accounts.resolver";
import { GenCheckoutFinishedGoodsComponent } from "../features/checkout/checkout-finished-goods/checkout-finished-goods.component";
import { GenCheckoutServicePartsComponent } from "../features/checkout/checkout-service-parts/checkout-service-parts.component";
import { CheckoutAuthGuard } from "@spartacus/checkout/base/components";
import { CartValidationGuard } from "@spartacus/cart/base/core";
import { GenCartReloadGuard } from "src/app/generac/guards/cart-reload.guard";
import { GenCartNotEmptyGuard } from "src/app/generac/guards/cart-not-empty.guard";
import { OrderConfirmationGuard } from "@spartacus/order/components";
import { GenOrderConfirmationThankYouMessageComponent } from "../features/order/order-confirmation/order-confirmation-thank-you-message/order-confirmation-thank-you-message.component";
import { GenOrderSummaryComponent } from "../shared/components/order-summary/order-summary.component";
import { GenCartDetailsComponent } from "../features/cart/cart-details/cart-details.component";
import { GenCartCouponComponent } from "../features/cart/cart-coupon/cart-coupon.component";
import { GenBreadcrumbComponent } from "../features/breadcrumb/breadcrumb.component";
import { GenCheckoutPaymentTypeComponent } from "../features/checkout/checkout-payment-type/checkout-payment-type.component";
import { GenCheckoutPlaceOrderComponent } from "../features/checkout/checkout-place-order/checkout-place-order.component";
import { GenCheckoutReviewSubmitComponent } from "../features/checkout/checkout-review-submit/checkout-review-submit.component";
import { GenCartProceedToCheckoutComponent } from "../features/cart/cart-proceed-to-checkout/cart-proceed-to-checkout.component";
import { GenFooterNavigationComponent } from "../features/footer-navigation/footer-navigation.component";
import { GenAddToCartComponent } from "../features/cart/product-add-to-cart/product-add-to-cart.component";
import { GenOrderDetailItemsComponent } from "../features/order/order-details/order-detail-items/order-detail-items.component";
import { GenOrderDetailShippingComponent } from "../features/order/order-details/order-detail-shipping/order-detail-shipping.component";
import { GenOrderConfirmationItemsComponent } from "../features/order/order-confirmation/order-confirmation-items/order-confirmation-items.component";
import { GenOrderConfirmationTotalsComponent } from "../features/order/order-confirmation/order-confirmation-totals/order-confirmation-totals.component";
import { GenCheckoutDeliveryAddressComponent } from "../features/checkout/checkout-delivery-address/checkout-delivery-address.component";
import { GenCheckoutScheduleReplenishmentOrderComponent } from "../features/checkout/checkout-schedule-replenishment-order/checkout-schedule-replenishment-order.component";
import { GenCheckoutSpecialHandlingComponent } from "../features/checkout/checkout-special-handling/checkout-special-handling.component";
import { GenSpecialHandlingGuard } from "../guards/special-handling.guard";
import { GenFavoritesListComponent } from "../features/favorites/favorites-list/favorites-list.component";
import { GenProductIntroComponent } from "../features/product/product-intro/product-intro.component";
import { GenDownloadLinkComponent } from "../features/product/download-link/download-link.component";
import { GenAvailabilityDateComponent } from "../features/product/availabity-date/availability-date.component";
import { GenBannerCarouselComponent } from "../features/product/banner-carousel/banner-carousel.component";
import { GenLoginComponent } from "../features/user-account/login/login.component";
import { GenProductWarrantiesComponent } from "../features/product/product-warranties/product-warranties.component";
import { GenProductSuggestionsComponent } from "../features/product/product-suggestions/product-suggestions.component";
import { GenProductReferencesComponent } from "../features/product/product-references/product-references.component";
import { GenProductHeaderMenuComponent } from "../features/product/product-header-menu/product-header-menu.component";
import { GenProductCarouselComponent } from "../features/product/product-carousel/product-carousel.component";
import { GenProductAccessoriesComponent } from "../features/product/product-accessories/product-accessories.component";
import { GenProductListComponent } from "../features/product/product-list/product-list.component";
import { GenProductSummaryComponent } from "../features/product/product-summary/product-summary.component";
import { GenQuickOrderComponent } from "../features/quick-order/quick-order.component";
import { CmsQuickOrderComponent } from "@spartacus/cart/quick-order/core";
import { GenSearchBoxComponent } from "../features/search-box/search-box.component";
import { GenAddToSavedCartComponent } from "../features/saved-cart/components/add-to-saved-cart/add-to-saved-cart.component";
import { GenCategoryNavigationComponent } from "../features/category-navigation/category-navigation/category-navigation.component";
import { GenHeaderNavigationComponent } from "../features/category-navigation/header-navigation/header-navigation.component";
import { GenApplicableProductsComponent } from "../features/product/product-tabs/applicable-products/applicable-products.component";
import { GenProductNotesComponent } from "../features/product/product-tabs/product-notes/product-notes.component";
import { GenTabParagraphContainerComponent } from "../features/tab-paragraph-container/tab-paragraph-container.component";
import { GenLoginFormComponent } from "../features/user-account/login-form/login-form.component";
import { GenDealerAcquisitionProductsComponent } from "../features/dealer-acquisition-products/dealer-acquisition-products.component";
import { GenProductBundleListComponent } from "../features/product/product-bundle-list/product-bundle-list.component";
import { GenSubscriptionsComponent } from "../features/subscriptions/subscriptions.component";
import { GenProductAttributesComponent } from "../features/product/product-tabs/product-attributes/product-attributes.component";
import { GenProductDocumentListComponent } from '../features/product/product-tabs/product-document-list/product-document-list.component';
import { GenBannerComponent } from "../shared/components/banner/banner.component";
import { GenEnergyManagementSystemComponent } from "../shared/components/energy-management-system/energy-management-system.component";
import { GenFooterCopyrightParagraphComponent } from "../shared/components/footer-copyright-paragraph/footer-copyright-paragraph.component";
import { GenSpecialProgramComponent } from "../features/special-program/special-program.component";
import { GenQuickOrderLinkComponent } from '../features/quick-order-link/quick-order-link.component';
import { GenCartSppFormValidatedGuard } from "../guards/cart-spp-form-validated-guard";
import { GenCheckoutEngineReplacementFormComponent } from "../features/checkout/checkout-engine-replacement-form/checkout-engine-replacement-form.component";
import { GenMiniCartComponent } from "../features/mini-cart/mini-cart.component";
import { GenAutoShipProductsComponent } from "../features/auto-ship/auto-ship-products/auto-ship-products.component";
import { GenAutoShipShipmentScheduleComponent } from "../features/auto-ship/auto-ship-shipment-schedule/auto-ship-shipment-schedule.component";

export const genCmsConfig: CmsConfig = {
  cmsComponents: {
    ReturningCustomerLoginComponent: {
      component: GenLoginFormComponent,
    },
    LoginComponent: {
      component: GenLoginComponent,
    },
    AddressFormComponent: {
      component: GenAddressFormComponent,
    },
    BreadcrumbComponent: {
      component: GenBreadcrumbComponent,
    },
    BundleHomepageCarouselComponent: {
      component: GenBundleCarouselComponent,
    },
    ProductDetailsBundlesComponent: {
      component: GenBundleCarouselComponent,
    },
    GeneracDealerAcquisitionProductsCarouselComponent: {
      component: GenDealerAcquisitionProductsComponent,
    },
    SubscriptionsComponent: {
      component: GenSubscriptionsComponent
    },
    ProductBundleListComponent: {
      component: GenProductBundleListComponent,
    },
    GeneracFooterNavigationComponent: {
      component: GenFooterNavigationComponent,
    },
    SavedAddressesComponent: {
      component: GenSavedAddressesComponent,
    },
    ProductRefinementComponent: {
      component: GenProductFacetNavigationComponent,
    },
    ProductImagesComponent: {
      component: GenProductImageZoomProductImagesComponent,
    },
    ShippingAccountsComponent: {
      component: GenShippingAccountsComponent,
      providers: [{
        provide: PageMetaResolver,
        useExisting: GenShippingAccountsResolver,
        multi: true,
      }]
    },
    NavigationUIComponent: {
      component: GenHeaderNavigationComponent
    },
    CategoryNavigationComponent: {
      component: GenCategoryNavigationComponent,
      data: {
        resetMenuOnClose: true,
      } as any,
    },
    SearchBoxComponent: {
      component: GenSearchBoxComponent,
    },
    CheckoutFinishedGoods: {
      component: GenCheckoutFinishedGoodsComponent,
      guards: [CheckoutAuthGuard, GenCartNotEmptyGuard, CartValidationGuard, GenCartReloadGuard, GenCartSppFormValidatedGuard],
    },
    CheckoutServiceParts: {
      component: GenCheckoutServicePartsComponent,
      guards: [CheckoutAuthGuard, GenCartNotEmptyGuard, CartValidationGuard, GenCartReloadGuard, GenCartSppFormValidatedGuard],
    },
    CheckoutScheduleReplenishmentOrderComponent: {
      component: GenCheckoutScheduleReplenishmentOrderComponent,
    },
    CheckoutDeliveryMode: {
      component: GenCheckoutSpecialHandlingComponent,
      guards: [GenSpecialHandlingGuard, CheckoutAuthGuard, GenCartNotEmptyGuard, CartValidationGuard, GenCartSppFormValidatedGuard],
    },
    CheckoutDeliveryAddress: {
      component: GenCheckoutDeliveryAddressComponent,
      guards: [CheckoutAuthGuard, GenCartNotEmptyGuard, CartValidationGuard, GenCartReloadGuard, GenCartSppFormValidatedGuard],
    },
    CheckoutSubscriptionInfo: {
      component: GenCheckoutDeliveryAddressComponent,
      guards: [CheckoutAuthGuard, GenCartNotEmptyGuard, CartValidationGuard, GenCartReloadGuard, GenCartSppFormValidatedGuard],
    },
    CheckoutCostCenterComponent: {
      component: [],
    },
    OrderConfirmationThankMessageComponent: {
      component: GenOrderConfirmationThankYouMessageComponent,
      guards: [OrderConfirmationGuard],
    },
    CartTotalsComponent: {
      component: GenOrderSummaryComponent,
    },
    CartComponent: {
      component: GenCartDetailsComponent,
    },
    AddToSavedCartsComponent: {
      component: GenAddToSavedCartComponent,
    },
    CartApplyCouponComponent: {
      component: GenCartCouponComponent,
    },
    CartProceedToCheckoutComponent: {
      component: GenCartProceedToCheckoutComponent,
    },
    CheckoutOrderSummary: {
      component: GenOrderSummaryComponent,
    },
    CheckoutPaymentType: {
      component: GenCheckoutPaymentTypeComponent,
      guards: [CheckoutAuthGuard, GenCartNotEmptyGuard, CartValidationGuard, GenCartSppFormValidatedGuard],
    },
    CheckoutReviewOrder: {
      component: GenCheckoutReviewSubmitComponent,
      guards: [CheckoutAuthGuard, GenCartNotEmptyGuard, GenCartSppFormValidatedGuard],
    },
    CheckoutPlaceOrder: {
      component: GenCheckoutPlaceOrderComponent,
      guards: [CheckoutAuthGuard, GenCartNotEmptyGuard, GenCartSppFormValidatedGuard],
    },
    AccountOrderDetailsItemsComponent: {
      component: GenOrderDetailItemsComponent,
      data: ({
        enableAddToCart: true,
      }) as CmsOrderDetailItemsComponent,
    },
    AccountOrderDetailsShippingComponent: {
      component: GenOrderDetailShippingComponent,
    },
    OrderConfirmationItemsComponent: {
      component: GenOrderConfirmationItemsComponent,
    },
    OrderConfirmationTotalsComponent: {
      component: GenOrderConfirmationTotalsComponent,
    },
    OrderConfirmationOverviewComponent: {
      component: GenOrderDetailShippingComponent,
    },
    ReplenishmentConfirmationOverviewComponent: {
      component: GenOrderDetailShippingComponent,
    },
    ProductAddToCartComponent: {
      component: GenAddToCartComponent,
      data: {
        otherProperties: {
          shouldUseCallForPricingTooltip: true
        }
      }
    },
    FavoritesComponent: {
      component: GenFavoritesListComponent,
    },
    ProductIntroComponent: {
      component: GenProductIntroComponent,
    },
    ProductDownloadLinkComponent: {
      component: GenDownloadLinkComponent,
    },
    GeneracWarrantyApplicableProductsComponent: {
      component: GenApplicableProductsComponent,
    },
    ProductSpecsTabComponent: {
      component: GenProductAttributesComponent,
    },
    ManualsListComponent: {
      component: GenProductDocumentListComponent,
    },
    ProductNotesTabComponent: {
      component: GenProductNotesComponent,
    },
    ProductAvailabilityDateComponent: {
      component: GenAvailabilityDateComponent,
    },
    RotatingImagesComponent: {
      component: GenBannerCarouselComponent,
    },
    GeneracProductWarrantiesComponent: {
      component: GenProductWarrantiesComponent,
    },
    CartSuggestionComponent: {
      component: GenProductSuggestionsComponent,
    },
    ProductReferencesComponent: {
      component: GenProductReferencesComponent,
    },
    ProductHeaderMenuComponent: {
      component: GenProductHeaderMenuComponent,
    },
    ProductCarouselComponent: {
      component: GenProductCarouselComponent,
    },
    ValueComparisonChart: {
      component: GenEnergyManagementSystemComponent,
    },
    RecentlyViewedProductsCarouselComponent: {
      component: GenProductCarouselComponent,
    },
    GeneracCloseoutProductCarouselComponent: {
      component: GenProductCarouselComponent,
    },
    TabsProductCarouselComponent: {
      component: GenProductAccessoriesComponent,
    },
    CMSProductListComponent: {
      component: GenProductListComponent,
    },
    ProductGridComponent: {
      component: GenProductListComponent,
    },
    SearchResultsListComponent: {
      component: GenProductListComponent,
    },
    ProductSummaryComponent: {
      component: GenProductSummaryComponent,
    },
    CMSTabParagraphContainer: {
      component: GenTabParagraphContainerComponent,
    },
    QuickOrderComponent: {
      component: GenQuickOrderComponent,
      data: {
        quickOrderListLimit: 10,
      } as CmsQuickOrderComponent,
    },
    SimpleResponsiveBannerComponent: {
      component: GenBannerComponent,
    },
    BannerComponent: {
      component: GenBannerComponent,
    },
    GeneracFooterCopyrightParagraphComponent: {
      component: GenFooterCopyrightParagraphComponent,
    },
    SpecialProgramComponent: {
      component: GenSpecialProgramComponent,
    },
    QuickOrderLinkComponent: {
      component: GenQuickOrderLinkComponent,
    },
    MiniCartComponent: {
      component: GenMiniCartComponent,
    },
    CheckoutEngineReplacementAttestation: {
      component: GenCheckoutEngineReplacementFormComponent,
      guards: [CheckoutAuthGuard, GenCartNotEmptyGuard, CartValidationGuard, GenCartReloadGuard, GenCartSppFormValidatedGuard],
    },
    GenAutoShipProductListComponent: {
      component: GenAutoShipProductsComponent,
    },
    GenAutoShipShipmentScheduleComponent: {
      component: GenAutoShipShipmentScheduleComponent,
    },
  }
}
